import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import { defaultOrgInterFormMain } from './defaultOrgInterMain';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomInputDate from '../../../../../../../components/CustomInputs/CustomInputDate';
import CustomInputMask from '../../../../../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../../../components/CustomRow';
import CustomSelect from '../../../../../../../components/CustomSelects/CustomSelect';
import StyledLink from '../../../../../../../components/Link';
import Log from '../../../../../../../components/Log/Log';
import ParteEnvolvidaComponente from '../../../../../../../components/ParteEnvolvida';
import ResponsavelAquisicaoComponente from '../../../../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../../../../components/SubAbas';
import TramitacaoComponente from '../../../../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { getUser } from '../../../../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../../../../modules/contexts/Select/useSelect';
import {
  IOrgInterForm,
  IOrgInterRegistro,
} from '../../../../../../../modules/types/OrgInterForm';
import { getOrgInter } from '../../../../../../../services/orgInters/orgIntersService';
import { functionLogData } from '../../../../../../../utils/functionLogData';
import { handleDelete } from '../../../../../../../utils/handleDelete';
import { handleSave } from '../../../../../../../utils/handleSave';
import SubAbasOrgInters from '../../../utils/subabasOrgInters';
import PlanoTrabalhoOrgInter from '../planoTrabalho';
import TermosReferenciasOrgInter from '../termoReferencia';
import TransferenciasFinanceirasOrgInter from '../transferenciasFinanceiras';

export default function OrgIntersDadosGeraisContent() {
  //DADOS USUARIO
  const user = getUser();
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.siglaInstituicao ?? 'Não informado';
  const userComponenteAFValue = user?.vinculo?.[0]?.numeroComponenteAF ?? 0;

  //COMPONENTE
  const params = useParams();
  const fichaID = String(params.id);

  const { getSelectDominioPai } = useSelect();
  const statusOrgInterOptions = getSelectDominioPai(52);
  const tipoOrgInterOptions = getSelectDominioPai(161);

  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);
  //OPTIONS

  const [dataRaw, setDataRaw] = useState<IOrgInterForm | null>(null);
  const [formMain, setFormMain] = useState<IOrgInterForm>(
    defaultOrgInterFormMain,
  );
  const [logData, setLogData] = useState<IOrgInterRegistro | null>(null);

  //Buscar dados
  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const registro = await getOrgInter(id);

      setLogData(registro);

      const dataInicio = registro.dataInicio
        ? new Date(registro.dataInicio).toISOString().split('T')[0]
        : '';

      const dataVigencia = registro.dataVigencia
        ? new Date(registro.dataVigencia).toISOString().split('T')[0]
        : '';

      const formValues: IOrgInterForm = {
        id: registro.id,
        statusOrgInter: Number(registro.statusOrgInter),
        componenteAf: Number(registro.componenteAf),
        numeroTC: registro.numeroTC,
        numeroTermoAjuste: registro.numeroTermoAjuste,
        nupTermoAjuste: registro.nupTermoAjuste,
        dataInicio: dataInicio,
        dataVigencia: dataVigencia,
        orgInternacional: registro.orgInternacional,
        observacoes: registro.observacoes,
      };

      setFormMain(formValues);
      setDataRaw(formValues);
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (fichaID !== 'undefined') {
      fetchData(fichaID);
    }
  }, [fichaID]);

  const subAbas =
    fichaID !== 'undefined'
      ? SubAbasOrgInters(fichaID)
      : [
          {
            label: 'Dados Gerais',
            rota: `/daf/proaq/orginters/dadosgerais`,
          },
        ];

  const logs = functionLogData(logData);

  //CRUD
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    setFormMain((prevState) => ({
      ...prevState,
      componenteAf: userComponenteAFValue, // Garante que o componente AF seja sempre atualizado com o valor do usuário
      [name]: value,
    }));
  };

  const camposBaseObrigatorios: Record<string, string> = {
    statusOrgInter: 'Status',
    numeroTC: 'Número do TC',
    numeroTermoAjuste: 'Número do Termo de Ajuste',
    nupTermoAjuste: 'NUP do Termo de Ajuste',
  };

  const camposAjustar = {
    number: ['id', 'usuarioId', 'statusOrgInter', 'componenteAf'],
    string: ['numeroTC', 'numeroTermoAjuste', 'nupTermoAjuste'],
    date: ['dataInicio', 'dataVigencia'],
  };

  const [camposObrigatorios, setCamposObrigatorios] = useState<
    Record<string, string>
  >(camposBaseObrigatorios);

  useEffect(() => {
    if (Number(formMain.statusOrgInter) in [54, 55, 56]) {
      // 1. Campos obrigatórios
      setCamposObrigatorios({
        ...camposBaseObrigatorios,
        dataInicio: 'Data de Início',
        dataVigencia: 'Data de Vigência',
      });
    } else {
      // 1. Remove campo obrigatório
      setCamposObrigatorios(camposBaseObrigatorios);

      setFormMain((prevState) => ({
        ...prevState,
        dataVigencia: '',
      }));
    }
  }, [formMain.statusOrgInter]);

  useEffect(() => {
    if (formMain.dataInicio == '' || Number(formMain.statusOrgInter) == 53) {
      setFormMain((prevState) => ({
        ...prevState,
        dataVigencia: '',
      }));
    }
  }, [formMain.dataInicio, formMain.statusOrgInter, formMain.dataVigencia]);

  const salvar = () =>
    handleSave(
      formMain,
      camposObrigatorios,
      camposAjustar,
      'orginter',
      'daf/proaq/orginters',
      fetchData,
      true,
      dataRaw,
    );

  const deletar = () =>
    handleDelete(fichaID, 'orginter', 'daf/proaq/orginters');

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/orginters"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {/* validação para evitar warning - no serve QueryFailedError: invalid input syntax for type integer: "NaN" */}
          {fichaID && fichaID !== 'undefined' && !isNaN(Number(fichaID)) && (
            <Log
              {...logs}
              entity="TB_ORG_INTER"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Identificação do Processo de Aquisição */}
          <BoxConteudo boxTitulo="Identificação do Processo de Aquisição">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="250px">
                <CustomSelect
                  title="Status"
                  name="statusOrgInter"
                  options={statusOrgInterOptions}
                  value={formMain.statusOrgInter}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomInputText
                  title="Componente AF"
                  name="componenteAf"
                  value={userComponenteAFLabel}
                  onChange={handleChange}
                  readOnly
                />
              </CustomCol>
              <CustomCol width="180px">
                <CustomInputText
                  title="Nº do TC"
                  name="numeroTC"
                  value={formMain.numeroTC}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomInputText
                  title="Nº do Termo de Ajuste"
                  name="numeroTermoAjuste"
                  value={formMain.numeroTermoAjuste}
                  onChange={handleChange}
                  required
                />
              </CustomCol>

              <CustomCol>
                <CustomInputMask
                  title="NUP do Termo de Ajuste"
                  name="nupTermoAjuste"
                  value={formMain.nupTermoAjuste}
                  onChange={handleChange}
                  mask="99999.999999/9999-99"
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <CustomInputDate
                  title="Data de Início"
                  name="dataInicio"
                  value={formMain.dataInicio}
                  onChange={handleChange}
                  required={formMain.statusOrgInter > 53}
                />
              </CustomCol>
              <CustomCol width="200px">
                <CustomInputDate
                  title="Data de Vigência"
                  name="dataVigencia"
                  value={formMain.dataVigencia}
                  onChange={handleChange}
                  minDate={
                    formMain.dataInicio
                      ? new Date(formMain.dataInicio)
                      : undefined
                  }
                  required={formMain.statusOrgInter >= 54}
                  readOnly={
                    formMain.dataInicio === '' ||
                    Number(formMain.statusOrgInter) < 54
                  }
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomSelect
                  title="Nome da Organização"
                  name="orgInternacional"
                  options={tipoOrgInterOptions}
                  value={formMain.orgInternacional}
                  onChange={handleChange}
                  disabled
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {fichaID && fichaID !== 'undefined' && !isNaN(Number(fichaID)) && (
            <>
              <PlanoTrabalhoOrgInter />

              <TransferenciasFinanceirasOrgInter />

              <TermosReferenciasOrgInter />

              <ParteEnvolvidaComponente tab="orgInter" id_tab={fichaID} />

              <ResponsavelAquisicaoComponente tab="orgInter" id_tab={fichaID} />
              <TramitacaoComponente tab="orgInter" id_tab={fichaID} />
            </>
          )}

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <CustomInputText
                  title="Observações"
                  name="observacoes"
                  value={formMain.observacoes}
                  type="textArea"
                  onChange={handleChange}
                  rows={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          save
          onClickSave={salvar}
          {...(fichaID !== 'undefined' && {
            delete: true,
            onClickDelete: deletar,
          })}
        />
      </BarraInferiorBotoes>
    </>
  );
}
